import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function StoryPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-20 pb-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            現場から生まれた、続けられる仕組み。
          </h1>
          <div className="w-24 h-1 bg-teal-500 mx-auto mb-8"></div>
        </div>
      </section>

      {/* Story Content */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gray-50 rounded-2xl p-8 md:p-12 mb-16">
            <div className="prose prose-lg max-w-none">
              <p className="text-lg leading-relaxed text-gray-700 mb-6">
                中学生の頃から支援してきた子が、高校生になって自発的にボランティアを始めました。
              </p>
              <p className="text-lg leading-relaxed text-gray-700 mb-6">
                しかし、時間や費用負担が重なり、受験期には続けたくても続けにくい現実がありました。
              </p>
              <p className="text-lg leading-relaxed text-gray-700 mb-6">
                だからこそ、ボランティアが無理なく継続でき、居場所も助かる仕組みが必要だと感じ、ボラタスを開発しました。
              </p>
              <p className="text-lg leading-relaxed text-teal-700 mb-6 font-medium">
                支援者が助かることが、結果的にこどもの支援の質と継続性につながる——それがボラタスの根底にある思想です。
              </p>
              <p className="text-xl font-semibold text-teal-600 text-center mt-8">
                「良いことを、続けられる形に」——それが私たちの出発点です。
              </p>
            </div>
          </div>

          {/* Team Member Card */}
          <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm">
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="w-32 h-32 rounded-full overflow-hidden flex-shrink-0">
                <img 
                  src="https://static.readdy.ai/image/8766ff501ca5aa7943b16e981fd86369/8f79ddfcd842983489a9396d182c421f.png"
                  alt="VIllehama"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 text-center md:text-left">
                <h3 className="text-xl font-bold text-gray-900 mb-2">VIllehama</h3>
                <p className="text-gray-600 mb-4">NPOでの現場経験あり</p>
                <div className="text-gray-700 space-y-3">
                  <p className="text-sm leading-relaxed">
                    母子家庭で育ち、昨今言われている相対的貧困世帯で過ごす。30代に差し掛かった事を期に、自分と同じ境遇のこどもたちに少しでも上手く生きる術を伝えたいと居場所と学習支援を行うNPOの活動に参加、居場所で過ごしたこどもたちが自主的にボランティアを開始した事をきかっけに、所属する『こどもの為のNPO』とは別に『支援者を支援する活動』を開始し、居場所とボランティアの為の学習支援マッチングサービス「boratasu」を作成した。
                  </p>
                  <p className="text-sm leading-relaxed font-medium text-teal-600">
                    居場所で働く人たちが、貧貧支援に陥らない様に、これから支援者側に回るこどもたちが嫌な思いをしない様に、社会に善い事をする大人が幸せになる為の環境作りに取り組んでいる。
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8">
            一緒に、良いことを続けませんか？
          </h2>
          <div className="flex justify-center">
            <a 
              href="https://boratasu.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer text-center"
            >
              サービスを使ってみる
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
